export const TGV_STATION_IATA_CODES = new Set<string>([
  'AGY',
  'AMR',
  'AVJ',
  'AVS',
  'BNJ',
  'BPO',
  'BPR',
  'BQZ',
  'BRF',
  'BZZ',
  'CDZ',
  'CEJ',
  'CFW',
  'CPJ',
  'DBL',
  'DDV',
  'DHU',
  'DUI',
  'DUQ',
  'EEL',
  'EEM',
  'EEP',
  'EER',
  'EEU',
  'EXS',
  'FES',
  'FGR',
  'FIS',
  'FVS',
  'GDU',
  'GEN',
  'GIA',
  'GJN',
  'GSY',
  'HBM',
  'HBP',
  'HBV',
  'HCJ',
  'HEC',
  'HEV',
  'HLY',
  'HSD',
  'HVT',
  'IBT',
  'ILF',
  'IMR',
  'INP',
  'IPR',
  'IPW',
  'IRR',
  'IRT',
  'ISR',
  'JEA',
  'JLL',
  'JQF',
  'JQJ',
  'JQO',
  'JXS',
  'KLT',
  'KVN',
  'KYN',
  'LGV',
  'LQP',
  'LQQ',
  'LQS',
  'LUY',
  'LWG',
  'MHZ',
  'MJX',
  'NDO',
  'NHZ',
  'NKJ',
  'NWK',
  'ORM',
  'OSQ',
  'OUQ',
  'OVI',
  'OZI',
  'OZU',
  'PCI',
  'PCW',
  'PFE',
  'PFL',
  'PIW',
  'PTE',
  'PXS',
  'PZC',
  'QAW',
  'QBO',
  'QDH',
  'QDU',
  'QEQ',
  'QEW',
  'QFB',
  'QFV',
  'QFZ',
  'QGL',
  'QGN',
  'QGV',
  'QHD',
  'QHX',
  'QII',
  'QIJ',
  'QJZ',
  'QKL',
  'QKU',
  'QLJ',
  'QLQ',
  'QLS',
  'QMO',
  'QMZ',
  'QNC',
  'QNM',
  'QOB',
  'QPP',
  'QQD',
  'QQH',
  'QQR',
  'QQS',
  'QQX',
  'QQY',
  'QRH',
  'QSG',
  'QUL',
  'QWB',
  'QWC',
  'QWU',
  'QXB',
  'QXG',
  'QXV',
  'QYE',
  'QYH',
  'QYI',
  'QYL',
  'QYM',
  'QYP',
  'QYU',
  'QYV',
  'QYX',
  'QZB',
  'RII',
  'RRA',
  'RZG',
  'SPO',
  'SSQ',
  'TCV',
  'TEJ',
  'TMV',
  'TPB',
  'TTK',
  'TTV',
  'TTZ',
  'TVX',
  'UER',
  'UGR',
  'USX',
  'UTL',
  'UWE',
  'UWP',
  'VBL',
  'VIO',
  'VWA',
  'VWB',
  'WEC',
  'WHZ',
  'WSS',
  'WXJ',
  'XAD',
  'XAH',
  'XAK',
  'XAW',
  'XAX',
  'XAZ',
  'XCC',
  'XCI',
  'XDB',
  'XDD',
  'XDG',
  'XDH',
  'XDL',
  'XDM',
  'XDO',
  'XDP',
  'XDQ',
  'XDS',
  'XDU',
  'XDV',
  'XDW',
  'XDY',
  'XDZ',
  'XEA',
  'XEC',
  'XED',
  'XEE',
  'XEF',
  'XEG',
  'XEH',
  'XEJ',
  'XEK',
  'XEL',
  'XEM',
  'XEV',
  'XEW',
  'XEY',
  'XEZ',
  'XFA',
  'XFC',
  'XFD',
  'XFE',
  'XFF',
  'XFG',
  'XFH',
  'XFI',
  'XFJ',
  'XFK',
  'XFL',
  'XFM',
  'XFO',
  'XFP',
  'XFQ',
  'XFS',
  'XFU',
  'XFV',
  'XFY',
  'XFZ',
  'XGC',
  'XGD',
  'XGH',
  'XGI',
  'XGJ',
  'XGK',
  'XGM',
  'XGP',
  'XGS',
  'XGU',
  'XGW',
  'XGY',
  'XGZ',
  'XHJ',
  'XHK',
  'XHL',
  'XHM',
  'XHN',
  'XHP',
  'XHS',
  'XHT',
  'XHU',
  'XHW',
  'XHX',
  'XIA',
  'XIB',
  'XID',
  'XIF',
  'XII',
  'XIK',
  'XIM',
  'XIO',
  'XIP',
  'XIT',
  'XIU',
  'XIV',
  'XIX',
  'XIZ',
  'XJA',
  'XJB',
  'XJC',
  'XJE',
  'XJG',
  'XJI',
  'XJJ',
  'XJL',
  'XJN',
  'XJO',
  'XJP',
  'XJQ',
  'XJS',
  'XJT',
  'XJV',
  'XJW',
  'XJY',
  'XKB',
  'XKC',
  'XKD',
  'XKE',
  'XKF',
  'XKG',
  'XKI',
  'XKJ',
  'XKK',
  'XKL',
  'XKM',
  'XKN',
  'XKP',
  'XKQ',
  'XKR',
  'XKV',
  'XKW',
  'XKZ',
  'XLJ',
  'XLK',
  'XLM',
  'XLP',
  'XLQ',
  'XLV',
  'XLY',
  'XLZ',
  'XMB',
  'XMZ',
  'XNB',
  'XNC',
  'XND',
  'XNE',
  'XNK',
  'XNM',
  'XNO',
  'XNV',
  'XOB',
  'XOC',
  'XOD',
  'XOF',
  'XOK',
  'XOL',
  'XON',
  'XOP',
  'XOQ',
  'XOU',
  'XPB',
  'XPF',
  'XPG',
  'XPH',
  'XPJ',
  'XPK',
  'XPN',
  'XPT',
  'XPW',
  'XPX',
  'XQB',
  'XQD',
  'XQE',
  'XQG',
  'XQH',
  'XQI',
  'XQL',
  'XQM',
  'XQT',
  'XQW',
  'XRC',
  'XRE',
  'XRF',
  'XRG',
  'XRJ',
  'XRK',
  'XRP',
  'XRU',
  'XSH',
  'XSR',
  'XSS',
  'XTI',
  'XTJ',
  'XTK',
  'XTQ',
  'XTY',
  'XUA',
  'XUB',
  'XUC',
  'XUE',
  'XUF',
  'XUG',
  'XUH',
  'XUI',
  'XUJ',
  'XUK',
  'XUL',
  'XUM',
  'XUO',
  'XUQ',
  'XUR',
  'XUS',
  'XUT',
  'XUU',
  'XUV',
  'XUW',
  'XUX',
  'XVA',
  'XVB',
  'XVC',
  'XVG',
  'XVH',
  'XVJ',
  'XVK',
  'XVQ',
  'XVS',
  'XVU',
  'XVV',
  'XVW',
  'XVX',
  'XVY',
  'XWA',
  'XWB',
  'XWD',
  'XWE',
  'XWG',
  'XWH',
  'XWI',
  'XWK',
  'XWL',
  'XWM',
  'XWN',
  'XWO',
  'XWP',
  'XWQ',
  'XWS',
  'XWT',
  'XWW',
  'XWX',
  'XWY',
  'XWZ',
  'XXC',
  'XXD',
  'XXE',
  'XXG',
  'XXJ',
  'XXK',
  'XXL',
  'XXM',
  'XXN',
  'XXO',
  'XXQ',
  'XXR',
  'XXT',
  'XXU',
  'XXV',
  'XXY',
  'XXZ',
  'XYB',
  'XYC',
  'XYD',
  'XYF',
  'XYG',
  'XYI',
  'XYJ',
  'XYL',
  'XYM',
  'XYN',
  'XYO',
  'XYP',
  'XYQ',
  'XYU',
  'XYV',
  'XYW',
  'XYX',
  'XYY',
  'XYZ',
  'XZB',
  'XZC',
  'XZD',
  'XZI',
  'XZK',
  'XZL',
  'XZN',
  'XZO',
  'XZT',
  'XZV',
  'XZZ',
  'YBD',
  'YBZ',
  'YCA',
  'YCN',
  'YEY',
  'YGX',
  'YHB',
  'YHN',
  'YJB',
  'YJC',
  'YJD',
  'YJE',
  'YJG',
  'YJH',
  'YJI',
  'YJL',
  'YJM',
  'YJR',
  'YJW',
  'YLD',
  'YLQ',
  'YMI',
  'YMY',
  'YPF',
  'YPG',
  'YPZ',
  'YQN',
  'YSH',
  'YTD',
  'YUG',
  'YUQ',
  'YVH',
  'YVS',
  'YWR',
  'YYI',
  'YYL',
  'YYW',
  'YZA',
  'ZAF',
  'ZAP',
  'ZAQ',
  'ZAU',
  'ZBA',
  'ZBB',
  'ZBH',
  'ZBJ',
  'ZBP',
  'ZBQ',
  'ZBT',
  'ZCB',
  'ZCC',
  'ZDA',
  'ZDC',
  'ZDD',
  'ZDE',
  'ZDG',
  'ZDI',
  'ZDJ',
  'ZDK',
  'ZDL',
  'ZDO',
  'ZDP',
  'ZDQ',
  'ZDR',
  'ZDS',
  'ZDT',
  'ZDU',
  'ZDV',
  'ZDW',
  'ZDX',
  'ZDZ',
  'ZEE',
  'ZEI',
  'ZEJ',
  'ZEP',
  'ZEU',
  'ZEX',
  'ZEY',
  'ZFI',
  'ZFJ',
  'ZFQ',
  'ZFR',
  'ZFT',
  'ZFZ',
  'ZGA',
  'ZGD',
  'ZGE',
  'ZGG',
  'ZGH',
  'ZGJ',
  'ZGO',
  'ZGW',
  'ZGX',
  'ZHB',
  'ZHC',
  'ZHD',
  'ZHE',
  'ZHF',
  'ZHG',
  'ZHH',
  'ZHI',
  'ZHJ',
  'ZHK',
  'ZHL',
  'ZHN',
  'ZHO',
  'ZHR',
  'ZHS',
  'ZHT',
  'ZHU',
  'ZHV',
  'ZHW',
  'ZHZ',
  'ZIB',
  'ZIF',
  'ZIJ',
  'ZIN',
  'ZIO',
  'ZIR',
  'ZIT',
  'ZIV',
  'ZJA',
  'ZJC',
  'ZJH',
  'ZJI',
  'ZJL',
  'ZJM',
  'ZJP',
  'ZJQ',
  'ZJS',
  'ZJU',
  'ZJV',
  'ZJW',
  'ZJZ',
  'ZKA',
  'ZKC',
  'ZKD',
  'ZKF',
  'ZKH',
  'ZKJ',
  'ZKK',
  'ZKN',
  'ZKO',
  'ZKS',
  'ZKU',
  'ZKV',
  'ZKW',
  'ZKX',
  'ZKZ',
  'ZLA',
  'ZLB',
  'ZLC',
  'ZLD',
  'ZLE',
  'ZLF',
  'ZLH',
  'ZLI',
  'ZLJ',
  'ZLK',
  'ZLL',
  'ZLM',
  'ZLN',
  'ZLP',
  'ZLQ',
  'ZLS',
  'ZLU',
  'ZLY',
  'ZME',
  'ZMG',
  'ZMI',
  'ZMQ',
  'ZMS',
  'ZMX',
  'ZMZ',
  'ZNB',
  'ZNQ',
  'ZNW',
  'ZOG',
  'ZOM',
  'ZOO',
  'ZOY',
  'ZPA',
  'ZPD',
  'ZPE',
  'ZPF',
  'ZPL',
  'ZPM',
  'ZPP',
  'ZPY',
  'ZQU',
  'ZQV',
  'ZRA',
  'ZRD',
  'ZRF',
  'ZRG',
  'ZRK',
  'ZRL',
  'ZRN',
  'ZRP',
  'ZRT',
  'ZRU',
  'ZRV',
  'ZRX',
  'ZRZ',
  'ZSB',
  'ZSC',
  'ZSD',
  'ZSF',
  'ZSG',
  'ZSI',
  'ZSK',
  'ZSN',
  'ZSO',
  'ZSQ',
  'ZSR',
  'ZSU',
  'ZSV',
  'ZSX',
  'ZSZ',
  'ZTD',
  'ZTE',
  'ZTF',
  'ZTG',
  'ZTJ',
  'ZTK',
  'ZTN',
  'ZTO',
  'ZTT',
  'ZTV',
  'ZTW',
  'ZTY',
  'ZTZ',
  'ZUA',
  'ZUG',
  'ZUJ',
  'ZUK',
  'ZUN',
  'ZVB',
  'ZVD',
  'ZVE',
  'ZVM',
  'ZWB',
  'ZWC',
  'ZWD',
  'ZWE',
  'ZWH',
  'ZWI',
  'ZWJ',
  'ZWM',
  'ZWN',
  'ZWP',
  'ZWT',
  'ZWU',
  'ZWV',
  'ZWW',
  'ZXA',
  'ZXE',
  'ZXM',
  'ZXO',
  'ZXP',
  'ZXS',
  'ZXU',
  'ZXX',
  'ZXY',
  'ZYA',
  'ZYE',
  'ZYG',
  'ZYH',
  'ZYM',
  'ZYN',
  'ZYO',
  'ZYP',
  'ZYQ',
  'ZYR',
  'ZYS',
  'ZYT',
  'ZYU',
  'ZYV',
  'ZYW',
  'ZYY',
  'ZYZ',
  'ZZN',
])
